/*
 * Sacred Essence - conversion helpers on the product page.
 *
 * Two things, both honest (no fake stock counters, no fake timers - under the
 * Australian Consumer Law an invented scarcity claim is misleading conduct):
 *
 *  1. FREE SHIPPING NUDGE. Works out what the cart would total if this product
 *     were added, and tells the customer exactly how far they are from the $100
 *     free-shipping threshold. Specific numbers move carts; a generic banner
 *     does not.
 *  2. TRUST ROW. Four short reassurances directly under the buy buttons, which
 *     is where hesitation actually happens.
 *
 * Thresholds must stay in sync with the Australia shipping zone and with
 * assets/se-rewards-bar.js.
 */
(function () {
  var TIER_SHIP = 10000;

  var ICONS = {
    truck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M14 9h4l4 4v4a1 1 0 0 1-1 1h-1"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    check:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m9 12 2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg>',
    shield:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>',
    lock:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    pin:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></svg>'
  };

  var CSS = [
    '.se-pn{--p:#4A2A7A;--ink:#150C22;margin:14px 0 0}',
    '.se-pn-ship{display:flex;align-items:center;gap:10px;background:#F1EBFA;border:1px solid #D6C9EE;border-radius:12px;padding:12px 14px;font-size:13.5px;line-height:1.4;color:var(--ink)}',
    '.se-pn-ship svg{width:19px;height:19px;flex:none;color:var(--p)}',
    '.se-pn-ship b{font-weight:700;color:var(--p)}',
    '.se-pn-ship--free{background:#EAF6F0;border-color:#BBE3CE}',
    '.se-pn-ship--free svg{color:#1F8A5B}',
    '.se-pn-ship--free b{color:#1F8A5B}',
    '.se-pn-trust{display:grid;grid-template-columns:1fr 1fr;gap:10px 18px;margin-top:14px;padding-top:14px;border-top:1px solid #E4DEF0}',
    '.se-pn-trust div{display:flex;align-items:center;gap:8px;font-size:12.5px;line-height:1.35;color:#5C5470}',
    '.se-pn-trust svg{width:16px;height:16px;flex:none;color:var(--p)}',
    '@media(max-width:520px){.se-pn-trust{grid-template-columns:1fr}}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('se-pn-styles')) return;
    var s = document.createElement('style');
    s.id = 'se-pn-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function handle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function trustRow() {
    return (
      '<div class="se-pn-trust">' +
      '<div>' + ICONS.shield + '<span>Sealed in its original packaging</span></div>' +
      '<div>' + ICONS.pin + '<span>Tracked, Australia-wide</span></div>' +
      '<div>' + ICONS.check + '<span>Official Australian pricing, in AUD</span></div>' +
      '<div>' + ICONS.lock + '<span>Secure checkout by Shopify</span></div>' +
      '</div>'
    );
  }

  function shipRow(projected) {
    if (projected >= TIER_SHIP) {
      return (
        '<div class="se-pn-ship se-pn-ship--free">' + ICONS.check +
        '<span><b>This order ships free.</b> You are over the $100 threshold.</span></div>'
      );
    }
    return (
      '<div class="se-pn-ship">' + ICONS.truck +
      '<span>Add <b>' + money(TIER_SHIP - projected) + '</b> more and shipping is free.</span></div>'
    );
  }

  function render(projected) {
    var anchor = document.querySelector('.buy-buttons-block');
    if (!anchor) return;

    injectStyles();

    var existing = document.querySelector('[data-se-pn]');
    var html = '<div class="se-pn" data-se-pn>' + shipRow(projected) + trustRow() + '</div>';

    if (existing) existing.outerHTML = html;
    else anchor.insertAdjacentHTML('afterend', html);
  }

  function refresh() {
    var h = handle();
    if (!h) return;

    Promise.all([
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ])
      .then(function (res) {
        var cart = res[0];
        var product = res[1];
        var inCart = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
        var variant = (product.variants || []).filter(function (v) { return v.available; })[0] || (product.variants || [])[0];
        var price = variant ? variant.price : product.price;
        render(inCart + (price || 0));
      })
      .catch(function () { /* leave the page as it was */ });
  }

  if (/\/products\//.test(window.location.pathname)) {
    document.addEventListener('cart:update', refresh);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh);
    } else {
      refresh();
    }
  }
})();
